import { css } from '@repo/pandacss/styled-system/css';
import { MdTune } from 'react-icons/md';

const outerClass = css({
  backgroundColor: 'neutral.lightest',
  borderTopLeftRadius: '3',
  borderTopRightRadius: '3',
  borderBottomRightRadius: '3',
  borderBottomLeftRadius: '3',
  height: '14',
  display: 'flex',
  alignItems: 'center',
  borderTopStyle: 'none',
  borderRightStyle: 'none',
  borderBottomStyle: 'none',
  borderLeftStyle: 'none',
  paddingTop: '2',
  paddingRight: '2',
  paddingBottom: '2',
  paddingLeft: '2',
  width: 'full',
});

const buttonClass = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingInlineStart: '4',
  paddingInlineEnd: '4',
  paddingBlockStart: '2',
  paddingBlockEnd: '2',
  borderTopLeftRadius: '3',
  borderTopRightRadius: '3',
  borderBottomRightRadius: '3',
  borderBottomLeftRadius: '3',
  backgroundColor: 'white',
  height: '10',
  width: 'full',
  cursor: 'pointer',
  borderTopWidth: 'none',
  borderRightWidth: 'none',
  borderBottomWidth: 'none',
  borderLeftWidth: 'none',
  fontSize: 'md',
  color: 'neutral.dark',
  fontWeight: 'medium',
  fontFamily: '[inherit]',
});

export const MobileFilterSortButton = ({
  handleOpenCloseDialog,
}: {
  handleOpenCloseDialog: () => void;
}) => (
  <div className={outerClass}>
    <button type="button" className={buttonClass} onClick={handleOpenCloseDialog}>
      <span>Filters &amp; Sort</span>
      <MdTune size={24} aria-hidden />
    </button>
  </div>
);
